module.exports = __webpack_public_path__ + "assets/img/header-bg@3x.b26b1f1f.png";